<template>
  <div>
    <el-container>
      <!-------头部部分开始-------------->
      <el-header>
        <div class="left">
          <div class="title_log" @click="jumpIndex">
            <img alt="" src="../static/title_logo.png" />
          </div>
          <div class="img"><img alt="" src="../static/logo.png" /></div>
          <div class="txt">
            <p class="p1">{{ $t("viewDetail.title") }}</p>
            <p class="p2">{{ $t("viewDetail.theme") }}</p>
            <p class="p3">{{ $t("viewDetail.time") }}</p>
          </div>
        </div>

        <div class="portrait">
          <div class="enlish">
            <!--中英文切换的功能按钮-->
            <p>
              <span @click="changeCn">中文</span>|<span @click="changeEn"
                >English</span
              >
            </p>
          </div>
          <el-col :span="25"
            ><span style="cursor: pointer; color: #ffffff" @click="outForm()">
              <i class="el-icon-switch-button" style="margin-right: 11px"></i>
              {{ $t("navbar.logout") }}</span
            ><span>
              <!-- <i class="el-icon-caret-bottom"></i> -->
            </span>
          </el-col>
        </div>
      </el-header>

      <!----------------------el-header结束---------------------------->
      <div>
        <el-dialog
          :close-on-click-modal="false"
          :visible.sync="dialogVisible"
          title="提示"
          width="20%"
        >
          <span>{{ $t("navbar.surelogout") }}</span>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="sure()">{{
              $t("navbar.sure")
            }}</el-button>
            <el-button size="small" @click="dialogVisible = false">{{
              $t("navbar.cancel")
            }}</el-button>
          </span>
        </el-dialog>
      </div>

      <!--------------------------------------------左侧栏部分开始------------------------------------------>
      <div class="container">
        <el-container>
          <el-row v-show="open" class="tac">
            <transition name="el-fade-in-linear">
              <el-col class="aisd">
                <el-menu
                  ref="menu"
                  :default-active="defaultActive"
                  active-text-color="#006fb8"
                  class="el-menu-vertical-demo"
                  text-color="#666666"
                  :default-openeds="openeds"
                >
                  <el-submenu index="1">
                    <template
                      ><span slot="title" class="link">{{
                        $t("navbar.hall")
                      }}</span></template
                    >

                    <router-link to="homeIndex">
                      <el-menu-item index="/backIndex/homeIndex">
                        <img
                          v-if="$route.path == '/backIndex/homeIndex'"
                          class="icon"
                          src="../static/icon/selected/shouye_selected.png"
                        />
                        <img
                          v-else
                          class="icon"
                          src="../static/icon/not_select/shouye.png"
                        />{{ $t("navbar.home") }}
                      </el-menu-item>
                    </router-link>

                    <router-link to="exhiIndex">
                      <el-menu-item index="/backIndex/exhiIndex">
                        <img
                          v-if="$route.path == '/backIndex/exhiIndex'"
                          class="icon"
                          src="../static/icon/selected/xinxi_selected.png"
                        />
                        <img
                          v-else
                          class="icon"
                          src="../static/icon/not_select/xinxi.png"
                        />{{ $t("navbar.exhibitor") }}
                      </el-menu-item>
                    </router-link>

                    <router-link to="productIndex">
                      <el-menu-item index="/backIndex/productIndex">
                        <img
                          v-if="
                            $route.path == '/backIndex/productIndex' ||
                            $route.path == '/backIndex/editproduct' ||
                            $route.path == '/backIndex/addproduct'
                          "
                          class="icon"
                          src="../static/icon/selected/chanpin_selected.png"
                        />
                        <img
                          v-else
                          class="icon"
                          src="../static/icon/not_select/chanpin.png"
                        />{{ $t("navbar.product") }}
                      </el-menu-item>
                    </router-link>

                    <!-- 直播活动 -->
                    <router-link to="active_list">
                      <el-menu-item
                        index="/backIndex/active_list"
                        v-if="Number(isCurrentYearUser)"
                      >
                        <img
                          v-if="
                            $route.path == '/backIndex/active_list' ||
                            $route.path == '/backIndex/add_active'
                          "
                          class="icon"
                          src="../static/icon/selected/huodong_selected.png"
                        />
                        <img
                          v-else
                          class="icon"
                          src="../static/icon/not_select/huodong.png"
                        />{{ $t("navbar.active") }}
                      </el-menu-item>
                    </router-link>

                    <router-link to="exhiLive">
                      <el-menu-item
                        index="/backIndex/exhiLive"
                        v-if="Number(isCurrentYearUser)"
                      >
                        <img
                          v-if="
                            $route.path == '/backIndex/exhiLive' ||
                            $route.path == '/backIndex/addExhiLive' ||
                            $route.path == '/backIndex/addexhiLive'
                          "
                          class="icon"
                          src="../static/icon/selected/zhibo_selected.png"
                        />
                        <img
                          v-else
                          class="icon"
                          src="../static/icon/not_select/zhibo.png"
                        />{{ $t("navbar.live") }}
                      </el-menu-item>
                    </router-link>

                    <router-link to="exhi_news">
                      <el-menu-item
                        index="/backIndex/exhi_news"
                        v-if="Number(isCurrentYearUser)"
                      >
                        <img
                          v-if="
                            $route.path == '/backIndex/exhi_news' ||
                            $route.path == '/backIndex/add_news'
                          "
                          class="icon"
                          src="../static/icon/selected/xinwen_selected.png"
                        />
                        <img
                          v-else
                          class="icon"
                          src="../static/icon/not_select/xinwen.png"
                        />{{ $t("navbar.news") }}
                      </el-menu-item>
                    </router-link>

                    <!-- 上传图片 -->
                    <!-- <div
                      class="uploadVideo"
                      @click="loginVr(VrUploadData.uploadImg)"
                    >
                      <el-menu-item>
                        <img
                          v-if="$route.path == '/backIndex/exhiIndex'"
                          class="icon"
                          src="../static/icon/selected/tupian_selected.png"
                        />
                        <img
                          v-else
                          class="icon"
                          src="../static/icon/not_select/tupian.png"
                        />
                        {{ $t("common.uploadExImg") }}</el-menu-item
                      >
                    </div> -->
                    <!-- 上传视频 -->
                    <!-- <div
                      class="uploadVideo"
                      @click="loginVr(VrUploadData.uploadVideo)"
                    >
                      <el-menu-item>
                        <img
                          v-if="$route.path == '/backIndex/exhiIndex'"
                          class="icon"
                          src="../static/icon/selected/shipin_selected.png"
                        />
                        <img
                          v-else
                          class="icon"
                          src="../static/icon/not_select/shipin.png"
                        />
                        {{ $t("common.uploadExVideo") }}</el-menu-item
                      >
                    </div> -->

                    <router-link to="dataIndex">
                      <el-menu-item index="/backIndex/dataIndex">
                        <img
                          v-if="
                            $route.path == '/backIndex/dataIndex' ||
                            $route.path == '/backIndex/uploadData'
                          "
                          class="icon"
                          src="../static/icon/selected/xuanchuan_selected.png"
                        />
                        <img
                          v-else
                          class="icon"
                          src="../static/icon/not_select/xuanchuan.png"
                        />{{ $t("navbar.publicize") }}
                      </el-menu-item>
                    </router-link>
                    <router-link to="mineMessage">
                      <el-menu-item index="/backIndex/mineMessage">
                        <img
                          v-if="
                            $route.path == '/backIndex/mineMessage' ||
                            $route.path == '/backIndex/messageDetail'
                          "
                          class="icon"
                          src="../static/icon/selected/xiaoxi_selected.png"
                        />
                        <img
                          v-else
                          class="icon"
                          src="../static/icon/not_select/xiaoxi.png"
                        />
                        <el-badge :is-dot="count != 0 ? true : false">
                          {{ $t("navbar.message") }}
                        </el-badge>
                      </el-menu-item>
                    </router-link>
                  </el-submenu>

                  <el-submenu index="2" v-if="Number(isCurrentYearUser)">
                    <template
                      ><span slot="title" class="link">{{
                        $t("navbar.service")
                      }}</span>
                    </template>
                    <router-link to="apply">
                      <el-menu-item @click="tiaozhuan" index="/backIndex/apply">
                        <img
                          v-if="$route.path == '/backIndex/apply'"
                          class="icon"
                          src="../static/icon/selected/tezhuang_selected.png"
                        />
                        <img
                          v-else
                          alt=""
                          class="icon"
                          src="../static/icon/not_select/tezhuang.png"
                        /><span
                          style="
                            display: inline-block;
                            width: 100%;
                            word-wrap: break-word;
                            white-space: normal;
                          "
                          >{{ $t("navbar.specal") }}</span
                        >
                      </el-menu-item>
                    </router-link>
                    <!-- 标摊门楣 -->
                    <!-- <router-link to="lintel">
                        <el-menu-item
                          @click="tiaozhuan"
                          index="/backIndex/lintel"
                        >
                          <img
                            v-if="$route.path == '/backIndex/lintel'"
                            class="icon"
                            src="../static/icon/selected/biaotan_selected.png"
                          />
                          <img
                            v-else
                            alt=""
                            class="icon"
                            src="../static/icon/not_select/biaotan.png"
                          /><span>{{ $t("navbar.lintel") }}</span>
                        </el-menu-item>
                      </router-link> -->
                    <router-link to="catalogue">
                      <el-menu-item index="/backIndex/catalogue">
                        <img
                          v-if="$route.path == '/backIndex/catalogue'"
                          class="icon"
                          src="../static/icon/selected/huikan_selected.png"
                        />
                        <img
                          v-else
                          alt=""
                          class="icon"
                          src="../static/icon/not_select/huikan.png"
                        /><span>{{ $t("navbar.catalogue") }}</span>
                      </el-menu-item>
                    </router-link>

                    <!-- 家具/绿植 -->
                    <!-- <router-link to="greenPlant">
                        <el-menu-item
                          @click="tiaozhuan"
                          index="/backIndex/greenPlant"
                        >
                          <img
                            v-if="$route.path == '/backIndex/greenPlant'"
                            class="icon"
                            src="../static/icon/selected/jiaju_selected.png"
                          />
                          <img
                            v-else
                            alt=""
                            class="icon"
                            src="../static/icon/not_select/jiaju.png"
                          />{{ $t("navbar.green") }}
                        </el-menu-item>
                      </router-link> -->

                    <!-- 参展商证 -->
                    <!-- <router-link to="card">
                      <el-menu-item index="/backIndex/card">
                        <img
                          v-if="$route.path == '/backIndex/card'"
                          class="icon"
                          src="../static/icon/selected/canzhanzheng_selected.png"
                        />
                        <img
                          v-else
                          alt=""
                          class="icon"
                          src="../static/icon/not_select/canzhanzheng.png"
                        />{{ $t("navbar.card") }}
                      </el-menu-item>
                    </router-link> -->

                    <!-- 测试三个地址特装申报、标准门楣、家具/绿植 -->
                    <!-- <router-link :to="{path:'/backIndex/apply',query:{userId:111}}">
                      <el-menu-item index="/backIndex/apply">
                        <img v-if="$route.path == '/backIndex/apply'" class="icon" src="../static/icon/selected/tezhuang_selected.png" />
                        <img v-else alt="" class="icon" src="../static/icon/not_select/tezhuang.png" /><span style="display:inline-block;width:100%;word-wrap:break-word;white-space:normal;">{{ $t('navbar.specal') }}</span>
                      </el-menu-item>
                    </router-link>
                  <router-link :to="{path:'/backIndex/lintel',query:{userId:111}}">
                      <el-menu-item index="/backIndex/lintel">
                        <img v-if="$route.path == '/backIndex/lintel'" class="icon" src="../static/icon/selected/biaotan_selected.png" />
                        <img v-else alt="" class="icon" src="../static/icon/not_select/biaotan.png" /><span style="display:inline-block;width:100%;word-wrap:break-word;white-space:normal;">{{ $t('navbar.lintel') }}</span>
                      </el-menu-item>
                    </router-link>
                    <router-link :to="{path:'/backIndex/greenPlant',query:{userId:111}}">
                      <el-menu-item index="/backIndex/greenPlant">
                        <img v-if="$route.path == '/backIndex/greenPlant'" class="icon" src="../static/icon/selected/jiaju_selected.png" />
                        <img v-else alt="" class="icon" src="../static/icon/not_select/jiaju.png" />{{ $t('navbar.green') }}
                      </el-menu-item>
                    </router-link> -->
                  </el-submenu>

                  <el-submenu index="3">
                    <template
                      ><span slot="title" class="link">{{
                        $t("navbar.invite")
                      }}</span></template
                    >
                    <!-- 微信邀请 -->
                    <router-link to="wxInvite">
                      <el-menu-item index="/backIndex/wxInvite">
                        <img
                          v-if="$route.path == '/backIndex/wxInvite'"
                          class="icon"
                          src="../static/icon/selected/weixin_selected.png"
                        />
                        <img
                          v-else
                          alt=""
                          class="icon"
                          src="../static/icon/not_select/weixin.png"
                        />{{ $t("navbar.wx") }}
                      </el-menu-item>
                    </router-link>

                    <router-link to="emailInvite">
                      <el-menu-item index="/backIndex/emailInvite">
                        <img
                          v-if="$route.path == '/backIndex/emailInvite'"
                          class="icon"
                          src="../static/icon/selected/email_selected.png"
                        />
                        <img
                          v-else
                          alt=""
                          class="icon"
                          src="../static/icon/not_select/email.png"
                        />{{ $t("navbar.email") }}
                      </el-menu-item>
                    </router-link>

                    <!-- PDF 邀请入口 -->
                    <router-link to="pdfInvite">
                      <el-menu-item index="/backIndex/pdfInvite">
                        <img
                          v-if="$route.path == '/backIndex/pdfInvite'"
                          class="icon"
                          src="../static/icon/selected/pdf_selected.png"
                        />
                        <img
                          v-else
                          alt=""
                          class="icon"
                          src="../static/icon/not_select/pdf.png"
                        />{{ $t("navbar.padfInite") }}
                      </el-menu-item>
                    </router-link>

                    <router-link to="groupInvite">
                      <el-menu-item index="/backIndex/groupInvite">
                        <img
                          v-if="$route.path == '/backIndex/groupInvite'"
                          class="icon"
                          src="../static/icon/selected/group_selected.png"
                        />
                        <img
                          v-else
                          alt=""
                          class="icon"
                          src="../static/icon/not_select/group.png"
                        />{{ $t("navbar.group") }}
                      </el-menu-item>
                    </router-link>
                  </el-submenu>

                  <router-link to="Download">
                    <el-menu-item index="/backIndex/Download">
                      <img
                        v-if="$route.path == '/backIndex/Download'"
                        class="icon"
                        src="../static/icon/selected/xiazai_selected.png"
                      />
                      <img
                        v-else
                        alt=""
                        class="icon"
                        src="../static/icon/not_select/xiazai.png"
                      />{{ $t("navbar.download") }}
                    </el-menu-item>
                  </router-link>

                  <router-link to="Connection">
                    <el-menu-item index="/backIndex/Connection">
                      <img
                        v-if="$route.path == '/backIndex/Connection'"
                        class="icon"
                        src="../static/icon/selected/lianxi_selected.png"
                      />
                      <img
                        v-else
                        alt=""
                        class="icon"
                        src="../static/icon/not_select/lianxi.png"
                      />{{ $t("navbar.connection") }}
                    </el-menu-item>
                  </router-link>

                  <router-link to="verifyPassword">
                    <el-menu-item index="/backIndex/verifyPassword">
                      <img
                        v-if="
                          $route.path == '/backIndex/verifyPassword' ||
                          $route.path == '/backIndex/editPassword'
                        "
                        class="icon"
                        src="../static/icon/selected/mima_selected.png"
                      />
                      <img
                        v-else
                        alt=""
                        class="icon"
                        src="../static/icon/not_select/mima.png"
                      />{{ $t("navbar.password") }}
                    </el-menu-item>
                  </router-link>
                </el-menu>
              </el-col>
            </transition>
          </el-row>
          <!-------左侧栏部分结束-------------->

          <!-------右侧部分开始-------------->
          <el-main class="elmain" style="overflow-y: hidden">
            <router-view />
          </el-main>
          <!-------右侧部分结束-------------->
        </el-container>
      </div>
    </el-container>
  </div>
</template>

<script>
import { logout } from "../../api/login.js";
import { backFront } from "../../utils/common.js";
import config from "../../config.js";
import { uploadImg } from "../../api/common.js";
import { VRLogin } from "../../utils/way.js";
import router from "../router/index.js";
export default {
  data() {
    return {
      open: true,
      openeds: ["1", "2", "3"],
      isCurrentYearUser: localStorage.getItem("isCurrentYearUser"),
      dialogVisible: false,
      fullscreen: false,
      backFront: backFront(),
      defaultActive: "",
      //VR上传资料相关的视频和图片地址
      VrUploadData: {
        uploadImg: config.vrUploadImg,
        uploadVideo: config.vrUploadVideo,
      },
      VrLoginFlag: false, //控制VR误触单点登录
      menushow: true,
    };
  },
  mounted() {
    // this.isCurrentYearUser = localStorage.getItem("isCurrentYearUser");
    // this.menushow = false;
    // this.$nextTick(() => {
    //   this.menushow = true;
    // });
  },
  created() {
    
    // this.isCurrentYearUser = localStorage.getItem("isCurrentYearUser")
    

    let i = this.$route.path;
    if (i == "/backIndex/editproduct" || i == "/backIndex/addproduct") {
      i = "/backIndex/productIndex";
    } else if (i == "/backIndex/add_active") {
      i = "/backIndex/active_list";
    } else if (i == "/backIndex/addExhiLive" || i == "/backIndex/addexhiLive") {
      i = "/backIndex/exhiLive";
    } else if (i == "/backIndex/add_news") {
      i = "/backIndex/exhi_news";
    } else if (i == "/backIndex/uploadData") {
      i = "/backIndex/dataIndex";
    } else if (i == "/backIndex/editPassword") {
      i = "/backIndex/verifyPassword";
    } else if (i == "/backIndex/messageDetail") {
      i = "/backIndex/myMessage";
    }
    this.defaultActive = i;

    //VR上传图片和视频链接地址
    this.VrUploadData.uploadImg = config.vrUploadImg;
    this.VrUploadData.uploadVideo = config.vrUploadVideo;
  },
  watch: {
    $route() {
      let i = this.$route.path;
      if (i == "/backIndex/editproduct" || i == "/backIndex/addproduct") {
        i = "/backIndex/productIndex";
      } else if (i == "/backIndex/add_active") {
        i = "/backIndex/active_list";
      } else if (
        i == "/backIndex/addExhiLive" ||
        i == "/backIndex/addexhiLive"
      ) {
        i = "/backIndex/exhiLive";
      } else if (i == "/backIndex/add_news") {
        i = "/backIndex/exhi_news";
      } else if (i == "/backIndex/uploadData") {
        i = "/backIndex/dataIndex";
      } else if (i == "/backIndex/editPassword") {
        i = "/backIndex/verifyPassword";
      } else if (i == "/backIndex/messageDetail") {
        i = "/backIndex/myMessage";
      }
      localStorage.setItem("index", i); //刷新
      setTimeout(() => {
        //路由跳转
        this.$refs.menu.activeIndex = i;
      }, 100);
    },
  },
  computed: {
    count() {
      return this.$store.state.count;
    },
  },
  methods: {
    stateSwitch() {
      this.open = !this.open;
    },
    tiaozhuan() {
      // window.open("http://baoguan.mhtexpo.com/e/128");
      window.open("http://gacec.mfdjw.com");
    },
    jumpIndex() {
      window.open(this.backFront);
    },
    sure() {
      sessionStorage.clear();
      this.dialogVisible = !this.dialogVisible;
      const id = localStorage.getItem("exid");
      localStorage.removeItem("name");
      localStorage.removeItem("companyName");
      const url = `${this.backFront}?zsFlag`;
      this.VRExit(id, url);
    },

    async logout() {
      try {
        const { data } = await logout();
        if (data.code == 200) {
          this.dialogVisible = true;
        } else {
          this.$message.error("注销失败");
        }
      } catch (error) {
        console.log(error);
      }
    },

    outForm() {
      this.logout();
    },

    VRExit(id, url) {
      const exId = id; //展商Id
      const that = this;
      const VrLoginData = { ...VRLogin(exId, that) };
      var hzExhibitor_id = VrLoginData.hzExhibitor_id;
      var time = parseInt(new Date().getTime() / 1000);
      var sign = VrLoginData.sign;
      var url = `${config.vrUrl}/ckjump/logout?hzExhibitor_id=${hzExhibitor_id}&sign=${sign}&time=${time}&url=${url}`;
      var a = document.createElement("a");
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    changeCn() {
      this.$i18n.locale = "zh";
      localStorage.setItem("lang", "zh");
      location.reload();
    },
    changeEn() {
      this.$i18n.locale = "en";
      localStorage.setItem("lang", "en");
      location.reload();
    },

    //Vr同步登录
    loginVr(url) {
      //拿到展商Id
      const exId = localStorage.getItem("exid");
      this.entryVr(exId, url);
    },

    //调用VR同步登录函数
    entryVr(id, url) {
      const exId = id; //展商Id
      if (true) {
        let that = this;
        const VrLoginData = { ...VRLogin(exId, that) };
        var hzExhibitor_id = VrLoginData.hzExhibitor_id;
        var time = parseInt(new Date().getTime() / 1000);
        var sign = VrLoginData.sign;
        var url = `${config.vrUrl}/ckjump/login?hzExhibitor_id=${hzExhibitor_id}&sign=${sign}&time=${time}&url=${url}`;
        var a = document.createElement("a");
        a.href = url;
        a.setAttribute("target", "_blank");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
  },
};
</script>
<style scoped>
* {
  margin: 0px;
  padding: 0px;
  text-decoration: none;
}

body,
html {
  height: 100%;
  width: 100%;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-image: url("../static/backImg.png");
  width: 100%;
  box-sizing: border-box;
  padding-right: 20px;
  height: 74px !important;
}

.title_log img {
  height: 62px;
  cursor: pointer;
}

.link {
  font-size: 18px;
  font-weight: 500;
  color: #006fb8;
}

.img img {
  height: 62px;
  margin: 0 10px 0 20px;
}

.enlish {
  margin-right: 20px;
  align-items: center;
}

.enlish p {
  display: block;
  line-height: 74px;
  color: white;
  font-size: 14px;
}

.enlish p span {
  margin-right: 5px;
  cursor: pointer;
}

.enlish p :last-child {
  margin-left: 5px;
}

.icon {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}

.el-menu {
  border: none;
}

.el-menu-item {
  /* color: #f0f0f0; */
  display: flex;
  align-items: center;
  /* border: 1px solid red; */

  overflow-wrap: break-word;
  /*color: #666666 !important;*/
  /*font-weight: 400px !important;*/
}
.el-menu-item span {
  display: block;
  width: 150px;

  white-space: normal;
  line-height: 24px;
  word-wrap: break-word;
  /* border: 1px solid black; */

  word-wrap: break-word;
}

/* .el-menu-item:hover {
  ferf  color: #006fb8 !important;
 background:; 
} */

.el-menu-item.is-active {
  background: #e8f6ff;
}

.el-main {
  background-color: #f0f2f5;
  color: #333;
  padding: 20px 30px !important;
}

.el-row >>> .el-col-24 {
  width: 220px;
  background: white !important;

  background-color: white;
}

.left {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  margin-left: 50px;
  color: white;
}

.el-header .title {
  font-size: 21px;
  margin-left: 30px;
}

.right {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 25px;
  margin-right: 50px;
  color: white;
}

.icon1 i {
  margin-right: 30px;
}

.portrait {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.portrait img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 30px;
}

.el-dropdown {
  position: relative;
  top: -2px;
}

.el-dropdown-link {
  cursor: pointer;
  color: white;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
</style>

<style scoped>
.dialog-footer >>> .el-button--small,
.el-button--small.is-round {
  padding: 9px 15px !important;
  box-sizing: border-box;
}
.el-badge >>> .el-badge__content.is-fixed {
  right: -7px !important;
  top: 17px !important;
}
</style>
